const mountingOptions = [
  { id: "ceiling", name: "Ceiling Mount", desc: "Attached to ceiling structure" },
  { id: "wall", name: "Wall Mount", desc: "Attached to walls" },
  { id: "floor-to-ceiling", name: "Floor to Ceiling", desc: "Spans full height" },
  { id: "freestanding", name: "Free-Standing Frame", desc: "Self-supporting frame" },
  { id: "ibeam", name: "I-Beam Clamp", desc: "Clamped to steel I-beams" },
];

const operationOptions = [
  { id: "sliding", name: "Sliding", desc: "Moves along a track system" },
  { id: "fixed", name: "Fixed", desc: "Permanently mounted in position" },
];

const trackOptions = [
  { id: "standard", name: "Standard Track" },
  { id: "heavy-duty", name: "Heavy-Duty Track" },
  { id: "galvanised", name: "Galvanised Track" },
];

export default function StepMounting({ form, setForm }) {
  const showTrack = form.operation === "sliding";

  return (
    <div>
      <h2
        className="text-2xl sm:text-3xl font-bold tracking-tight mb-2"
        style={{ fontFamily: "'Clash Display', sans-serif" }}
      >
        Mounting & Operation
      </h2>
      <p className="text-sm text-[#A3A3A3] mb-8">How should the product be mounted and operated?</p>

      {/* Operation */}
      <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4" style={{ fontFamily: "'Clash Display', sans-serif" }}>
        Operation
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-10 max-w-lg">
        {operationOptions.map((o) => {
          const selected = form.operation === o.id;
          return (
            <button
              key={o.id}
              type="button"
              data-testid={`operation-${o.id}`}
              onClick={() => setForm((prev) => ({ ...prev, operation: o.id, track_type: o.id === "fixed" ? "" : prev.track_type }))}
              className={`text-left p-5 border transition-all duration-200 ${
                selected
                  ? "border-[#FF5722] bg-[#FF5722]/5"
                  : "border-[#2E2E2E] bg-[#141414] hover:border-[#FF5722]/50"
              }`}
            >
              <p className={`font-bold text-sm ${selected ? "text-[#FF5722]" : "text-white"}`} style={{ fontFamily: "'Clash Display', sans-serif" }}>
                {o.name}
              </p>
              <p className="text-xs text-[#A3A3A3] mt-1">{o.desc}</p>
            </button>
          );
        })}
      </div>

      {/* Track Type (only if sliding) */}
      {showTrack && (
        <>
          <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4" style={{ fontFamily: "'Clash Display', sans-serif" }}>
            Track Type
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-10 max-w-2xl">
            {trackOptions.map((t) => {
              const selected = form.track_type === t.id;
              return (
                <button
                  key={t.id}
                  type="button"
                  data-testid={`track-${t.id}`}
                  onClick={() => setForm((prev) => ({ ...prev, track_type: t.id }))}
                  className={`text-center p-4 border transition-all duration-200 ${
                    selected
                      ? "border-[#FF5722] bg-[#FF5722]/5"
                      : "border-[#2E2E2E] bg-[#141414] hover:border-[#FF5722]/50"
                  }`}
                >
                  <p className={`font-bold text-sm ${selected ? "text-[#FF5722]" : "text-white"}`} style={{ fontFamily: "'Clash Display', sans-serif" }}>
                    {t.name}
                  </p>
                </button>
              );
            })}
          </div>
        </>
      )}

      {/* Mounting */}
      <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4" style={{ fontFamily: "'Clash Display', sans-serif" }}>
        Mounting Method
      </h3>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 max-w-3xl">
        {mountingOptions.map((m) => {
          const selected = form.mounting === m.id;
          return (
            <button
              key={m.id}
              type="button"
              data-testid={`mounting-${m.id}`}
              onClick={() => setForm((prev) => ({ ...prev, mounting: m.id }))}
              className={`text-left p-5 border transition-all duration-200 ${
                selected
                  ? "border-[#FF5722] bg-[#FF5722]/5"
                  : "border-[#2E2E2E] bg-[#141414] hover:border-[#FF5722]/50"
              }`}
            >
              <p className={`font-bold text-sm ${selected ? "text-[#FF5722]" : "text-white"}`} style={{ fontFamily: "'Clash Display', sans-serif" }}>
                {m.name}
              </p>
              <p className="text-xs text-[#A3A3A3] mt-1">{m.desc}</p>
            </button>
          );
        })}
      </div>
    </div>
  );
}
